export default function createAction(type) {
  return (payload) => ({
    type,
    payload,
  });
}

export const opeGlobalError = (title, errorMessage, onClose) => ({
  type: 'SWITCH_ERROR_MODAL',
  payload: {
    showErrorModal: true,
    title,
    errorMessage,
    onClose,
  },
});

export const closeGlobalError = () => ({
  type: 'SWITCH_ERROR_MODAL',
  payload: {
    showErrorModal: false,
    title: '',
    errorMessage: '',
    onClose: () => {},
  },
});
